var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 222,
    viewBox: "0 0 233 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.027 12.4554L19.6367 38.5225L55.6239 206.38L177.014 180.313L141.027 12.4554Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.586 15.7339L22.2979 40.9199L57.0686 203.104L174.357 177.918L139.586 15.7339Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.347 17.2483L24.0449 41.7932L58.0475 200.394L172.349 175.849L138.347 17.2483Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.224 16.5248L51.5205 28.7012L54.4677 42.4479L111.171 30.2715L108.224 16.5248Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9911 9.18639C72.6132 10.1275 69.8433 14.5259 70.8064 19.0097C71.7695 23.4934 76.0962 26.3707 80.4655 25.4296C84.8348 24.4885 87.6132 20.0901 86.6502 15.6063C85.6871 11.1226 81.3689 8.2453 76.9911 9.18639ZM79.7382 22.0092C78.813 22.2301 77.843 22.1702 76.9519 21.8373C76.0608 21.5043 75.2889 20.9134 74.7346 20.1397C74.1803 19.3661 73.8687 18.4448 73.8396 17.4933C73.8104 16.5418 74.065 15.6032 74.5709 14.797C75.0767 13.9908 75.811 13.3536 76.68 12.9667C77.5491 12.5797 78.5136 12.4604 79.4506 12.6241C80.3876 12.7878 81.2548 13.227 81.9415 13.8857C82.6281 14.5444 83.1033 15.3928 83.3064 16.3228C83.4467 16.9308 83.4657 17.5604 83.3621 18.1757C83.2586 18.791 83.0346 19.3797 82.703 19.9081C82.3715 20.4365 81.9389 20.8941 81.4301 21.2547C80.9213 21.6153 80.3463 21.8717 79.7382 22.0092Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 16.0635L51.9902 27.9834L54.8075 41.1241L110.317 29.2042L107.5 16.0635Z",
    fill: "#F34D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9912 9.18635C75.4569 9.51594 74.0546 10.2935 72.9618 11.4206C71.869 12.5478 71.1347 13.9739 70.8517 15.5187C70.5688 17.0635 70.7499 18.6576 71.3721 20.0994C71.9944 21.5412 73.0299 22.766 74.3477 23.6188C75.6654 24.4717 77.2063 24.9143 78.7754 24.8907C80.3445 24.8672 81.8714 24.3785 83.163 23.4865C84.4546 22.5944 85.4529 21.3391 86.0316 19.8793C86.6104 18.4195 86.7436 16.8206 86.4145 15.285C86.1959 14.2653 85.7788 13.2987 85.1869 12.4403C84.5951 11.5819 83.8401 10.8486 82.965 10.2823C82.09 9.71599 81.112 9.32772 80.087 9.13968C79.062 8.95163 78.0101 8.96749 76.9912 9.18635ZM79.6162 21.4405C78.7306 21.6307 77.8085 21.5538 76.9665 21.2195C76.1246 20.8852 75.4006 20.3085 74.8862 19.5624C74.3717 18.8162 74.0899 17.9342 74.0764 17.0278C74.0629 16.1214 74.3182 15.2313 74.8102 14.4701C75.3021 13.7089 76.0085 13.1109 76.8401 12.7515C77.6717 12.3922 78.5911 12.2877 79.482 12.4513C80.3729 12.615 81.1953 13.0393 81.8452 13.6707C82.4952 14.3021 82.9434 15.1123 83.1333 15.9987C83.3878 17.1871 83.1603 18.428 82.5007 19.4485C81.8412 20.469 80.8036 21.1856 79.6162 21.4405Z",
    fill: "#F34D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.418 33.2397H73.2646V204.918H197.418V33.2397Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M195.321 36.1428H75.3633V202.018H195.321V36.1428Z",
    fill: "url(#paint3_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.792 37.3652H76.8887V199.576H193.792V37.3652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.491 30.3313H106.497V44.3909H164.491V30.3313Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.494 16.6072C131.016 16.6072 127.386 20.3261 127.386 24.915C127.386 29.5039 131.016 33.2228 135.494 33.2228C139.971 33.2228 143.602 29.5039 143.602 24.915C143.602 20.3261 139.971 16.6072 135.494 16.6072ZM135.494 29.7087C134.542 29.7313 133.605 29.4694 132.802 28.9566C132 28.4438 131.368 27.7033 130.988 26.8296C130.608 25.9559 130.497 24.9887 130.669 24.0515C130.841 23.1142 131.288 22.2495 131.953 21.5677C132.618 20.8859 133.471 20.4179 134.403 20.2235C135.335 20.0291 136.304 20.1172 137.186 20.4764C138.068 20.8357 138.823 21.4498 139.354 22.2404C139.886 23.031 140.17 23.9621 140.17 24.915C140.179 26.1674 139.692 27.3724 138.816 28.2665C137.939 29.1605 136.745 29.6709 135.494 29.6859V29.7087Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.881 29.7285H107.108V43.1683H163.881V29.7285Z",
    fill: "#F34D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.494 16.6072C133.925 16.6072 132.391 17.0729 131.086 17.9455C129.781 18.8181 128.764 20.0583 128.164 21.5093C127.563 22.9604 127.406 24.557 127.712 26.0975C128.018 27.6379 128.774 29.0528 129.884 30.1634C130.993 31.274 132.407 32.0303 133.946 32.3367C135.485 32.6431 137.081 32.4859 138.531 31.8848C139.981 31.2838 141.22 30.266 142.092 28.9601C142.964 27.6542 143.429 26.1188 143.429 24.5482C143.429 22.4421 142.593 20.4223 141.105 18.9331C139.617 17.4438 137.599 16.6072 135.494 16.6072ZM135.494 29.1315C134.589 29.1304 133.705 28.8609 132.953 28.3571C132.201 27.8533 131.615 27.1378 131.268 26.3009C130.922 25.4639 130.832 24.5432 131.008 23.6548C131.185 22.7664 131.62 21.9503 132.26 21.3094C132.899 20.6686 133.714 20.2317 134.602 20.054C135.489 19.8764 136.409 19.9658 137.246 20.3112C138.083 20.6565 138.798 21.2422 139.303 21.9942C139.807 22.7463 140.077 23.6311 140.079 24.5369C140.079 25.139 139.96 25.7351 139.73 26.2912C139.499 26.8473 139.161 27.3525 138.735 27.7779C138.309 28.2032 137.804 28.5405 137.248 28.7703C136.692 29.0001 136.096 29.118 135.494 29.1173V29.1315Z",
    fill: "#F34D21"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.40607 209.558H4.33789V215.623H5.40607V209.558Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.90332 213.126V212.057H1.84367V213.126H7.90332Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.332 0H128.264V6.06455H129.332V0Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.829 3.56537V2.49634L125.769 2.49634V3.56537L131.829 3.56537Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M219.057 219.654C218.763 219.526 218.525 219.294 218.391 219.002C218.256 218.71 218.234 218.378 218.327 218.071C218.342 218.024 218.352 217.975 218.356 217.926C218.364 217.785 218.327 217.645 218.25 217.527C218.173 217.409 218.06 217.319 217.927 217.27C217.795 217.221 217.651 217.216 217.516 217.256C217.38 217.296 217.261 217.378 217.177 217.491C217.147 217.53 217.122 217.573 217.103 217.619C216.974 217.914 216.742 218.151 216.451 218.286C216.159 218.42 215.828 218.443 215.52 218.349C215.473 218.334 215.425 218.325 215.375 218.321C215.235 218.312 215.095 218.35 214.977 218.427C214.859 218.504 214.769 218.617 214.72 218.749C214.671 218.882 214.667 219.026 214.706 219.162C214.746 219.297 214.828 219.416 214.941 219.501C214.98 219.53 215.023 219.555 215.069 219.575C215.363 219.703 215.6 219.935 215.735 220.227C215.87 220.519 215.892 220.851 215.799 221.158C215.784 221.206 215.774 221.254 215.77 221.303C215.762 221.444 215.799 221.584 215.876 221.702C215.953 221.82 216.066 221.91 216.198 221.959C216.331 222.008 216.475 222.013 216.61 221.973C216.746 221.933 216.864 221.851 216.949 221.738C216.979 221.699 217.004 221.656 217.023 221.611C217.151 221.316 217.384 221.078 217.675 220.944C217.967 220.809 218.298 220.786 218.606 220.88C218.653 220.895 218.701 220.904 218.75 220.908C218.891 220.917 219.031 220.88 219.149 220.803C219.267 220.725 219.357 220.612 219.406 220.48C219.454 220.347 219.459 220.203 219.42 220.068C219.38 219.932 219.298 219.813 219.185 219.728C219.146 219.699 219.103 219.674 219.057 219.654Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.8268 161.352C38.5321 161.223 38.2949 160.991 38.1603 160.699C38.0257 160.407 38.003 160.076 38.0966 159.768C38.1117 159.721 38.1213 159.672 38.1251 159.623C38.1335 159.482 38.0965 159.342 38.0194 159.224C37.9423 159.106 37.8293 159.016 37.697 158.967C37.5647 158.919 37.4203 158.914 37.2851 158.953C37.1498 158.993 37.031 159.075 36.9461 159.188C36.9165 159.228 36.8917 159.271 36.8722 159.316C36.744 159.611 36.5119 159.848 36.2201 159.983C35.9283 160.118 35.5972 160.14 35.2898 160.047C35.2428 160.032 35.1942 160.022 35.1449 160.018C35.0042 160.01 34.8646 160.047 34.7465 160.124C34.6285 160.201 34.5385 160.314 34.4897 160.447C34.441 160.579 34.4361 160.724 34.4758 160.859C34.5155 160.994 34.5977 161.113 34.7103 161.198C34.7499 161.228 34.7928 161.253 34.8381 161.272C35.1327 161.4 35.3699 161.633 35.5046 161.925C35.6392 162.217 35.6619 162.548 35.5682 162.856C35.5531 162.903 35.5436 162.951 35.5398 163.001C35.5313 163.142 35.5684 163.281 35.6455 163.399C35.7226 163.518 35.8356 163.608 35.9679 163.656C36.1001 163.705 36.2446 163.71 36.3798 163.67C36.5151 163.631 36.6339 163.548 36.7188 163.436C36.7483 163.396 36.7731 163.353 36.7927 163.308C36.9209 163.013 37.153 162.776 37.4448 162.641C37.7366 162.506 38.0677 162.483 38.3751 162.577C38.4221 162.592 38.4707 162.602 38.5199 162.606C38.6606 162.614 38.8003 162.577 38.9183 162.5C39.0363 162.423 39.1264 162.309 39.1751 162.177C39.2239 162.045 39.2288 161.9 39.1891 161.765C39.1493 161.63 39.0671 161.511 38.9546 161.426C38.915 161.396 38.8721 161.371 38.8268 161.352Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M188.943 19.3849C188.648 19.2565 188.411 19.0243 188.277 18.7322C188.142 18.4402 188.119 18.1089 188.213 17.8012C188.228 17.7542 188.238 17.7055 188.241 17.6562C188.25 17.5154 188.213 17.3756 188.136 17.2575C188.058 17.1394 187.945 17.0493 187.813 17.0005C187.681 16.9517 187.537 16.9468 187.401 16.9866C187.266 17.0263 187.147 17.1086 187.062 17.2212C187.033 17.2608 187.008 17.3038 186.988 17.3492C186.86 17.644 186.628 17.8814 186.336 18.0162C186.045 18.1509 185.713 18.1736 185.406 18.0799C185.359 18.0648 185.31 18.0552 185.261 18.0514C185.12 18.043 184.981 18.08 184.863 18.1572C184.745 18.2344 184.655 18.3475 184.606 18.4798C184.557 18.6122 184.552 18.7568 184.592 18.8921C184.632 19.0275 184.714 19.1464 184.826 19.2314C184.866 19.2609 184.909 19.2857 184.954 19.3053C185.249 19.4337 185.486 19.6659 185.621 19.9579C185.755 20.25 185.778 20.5813 185.684 20.889C185.669 20.936 185.66 20.9847 185.656 21.034C185.648 21.1748 185.685 21.3146 185.762 21.4327C185.839 21.5508 185.952 21.6409 186.084 21.6897C186.216 21.7385 186.361 21.7434 186.496 21.7036C186.631 21.6639 186.75 21.5816 186.835 21.469C186.865 21.4294 186.889 21.3864 186.909 21.341C187.037 21.0462 187.269 20.8088 187.561 20.674C187.853 20.5393 188.184 20.5166 188.491 20.6103C188.538 20.6254 188.587 20.635 188.636 20.6388C188.777 20.6472 188.917 20.6102 189.035 20.533C189.153 20.4558 189.243 20.3427 189.291 20.2104C189.34 20.078 189.345 19.9334 189.305 19.7981C189.266 19.6627 189.183 19.5438 189.071 19.4588C189.031 19.4293 188.988 19.4044 188.943 19.3849Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.864 91.5511C232.045 91.5511 233.003 90.5926 233.003 89.4102C233.003 88.2278 232.045 87.2693 230.864 87.2693C229.682 87.2693 228.725 88.2278 228.725 89.4102C228.725 90.5926 229.682 91.5511 230.864 91.5511Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.5484 214.429C66.7298 214.429 67.6876 213.47 67.6876 212.288C67.6876 211.105 66.7298 210.147 65.5484 210.147C64.3669 210.147 63.4092 211.105 63.4092 212.288C63.4092 213.47 64.3669 214.429 65.5484 214.429Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M208.895 137.827C210.076 137.827 211.034 136.868 211.034 135.686C211.034 134.504 210.076 133.545 208.895 133.545C207.714 133.545 206.756 134.504 206.756 135.686C206.756 136.868 207.714 137.827 208.895 137.827Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.7554 29.5353C25.9369 29.5353 26.8946 28.5768 26.8946 27.3943C26.8946 26.2119 25.9369 25.2534 24.7554 25.2534C23.574 25.2534 22.6162 26.2119 22.6162 27.3943C22.6162 28.5768 23.574 29.5353 24.7554 29.5353Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.1392 87.9374C3.32065 87.9374 4.27841 86.9789 4.27841 85.7965C4.27841 84.614 3.32065 83.6555 2.1392 83.6555C0.957754 83.6555 0 84.614 0 85.7965C0 86.9789 0.957754 87.9374 2.1392 87.9374Z",
    fill: "#47E6B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 115.711,
    y1: 190.511,
    x2: 80.8868,
    y2: 28.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 31195,
    y1: -4065.46,
    x2: 31049,
    y2: -4745.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 9109.02,
    y1: 463.717,
    x2: 8905.39,
    y2: -484.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 57223.1,
    y1: 117895,
    x2: 57223.1,
    y2: 21122.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 27766.3,
    y1: 2225.46,
    x2: 27766.3,
    y2: 1530.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 10941.1,
    y1: 2947.44,
    x2: 10941.1,
    y2: 1976.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 222,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawNoData);
export default __webpack_public_path__ + "static/media/undraw_no_data.585eb4d4a117b20123229a187d9a21a2.svg";
export { ForwardRef as ReactComponent };